/**
 * Reeluxs WhatsApp CTA tracking.
 * Any <a data-wb-wa="sell|consign|product|..."> click fires a GA4 event.
 * GA4 itself is wired at Phase 3 cutover — until gtag / dataLayer exists on the
 * page this stays silent, but the click data starts flowing the moment it does.
 */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[data-wb-wa]') : null;
    if (!link) return;
    var payload = {
      flow: link.getAttribute('data-wb-wa'),
      link_url: link.href,
      page_path: window.location.pathname,
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'wb_whatsapp_click', payload);
    } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: 'wb_whatsapp_click' }, payload));
    }
  });
})();
